export const DEFAULT_CACHE_DURATION = 1800000; // 30 minute
export const DEFAULT_ONE_DAY_DURATION = 86400; // 1 day in seconds